import "./accordions";
import "./wheel";
import "./header";
import "./hero";
import "./glossary-links";